module.exports = __webpack_public_path__ + "static/media/10.b9a9c44d.jpg";